import { brand as _brandManifest } from "../branding/generated/brand-manifest";

export const HomePageNav = {
  LANDING_PAGE: "LANDING_PAGE",
  STARTING_DESTINATION: "STARTING_DESTINATION",
  PREFERENCES: "PREFERENCES",
  SELECTED_PREFERENCES: "SELECTED_PREFERENCES",
} as const;

export const HOME_INFO_MESSAGE = {
  first: `Hi I’m ${_brandManifest.assistantName}, your personal travel assistant. What should we explore today?`,
  // first: `<h2 align=center>Hi I'm Zoya<br> Your personal travel assistant. </h2>`,
  second: `<h1>Your perfect trip starts here! Share your style, must-dos, and dates—I’ll craft an experience that’s so <i>you</I>.<br><br> I can also help you plan and book your flights and hotels</h1>`,
};

export const DATA_STREAMING_KEY = {
  ERROR: "error",
  STATEMENT: {
    key: "statement",
  },
  INTENT: {
    KEY: "intent",
    RETURN_TYPE: "return_type",
    PRE_TEXT: "pretext",
    POST_TEXT: "posttext",
    DAILY_PLAN: "daily_plan",
    ITINERARY_SUMMARY: "itinerary_summary",
    BOOKING: "booking",
    TRIP_PREFERENCE: "trip_preference",
    FOLLOW_UP: "followup",
    DESTINATION: "destination",
  },
  REUTRN_TYPE: {
    DESTINATIONS: "destinations",
    ITINERARY: "itinerary",
    FOLLOW_UP: "followup",
    BOOKING: "booking",
  },
  EVENTS: {
    STREAM: "stream",
    RETURN_TYPE: "return-type",
    STATUS: "status",
    COMPLETED: "completed",
    DONE: "[DONE]",
  },
};

export const ENVIRONMENT_TYPE = {
  LOCAL: "local",
  DEV: "development",
  PRODUCTION: "production",
  STAGING: "staging",
  TEST: "test",
};

export const DialogSelected = {
  LOGIN: "LOGIN",
  CREATE_ACCOUNT: "CREATE_ACCOUNT",
  SAVE_ITINERARY: "SAVE_ITINERARY",
  SAVE_ACTIVITY: "SAVE_ACTIVITY",
  EDIT_PROMPT: "EDIT_PROMPT",
  EDIT_PREFER: "Edit_Prefer",
  EDIT_ACCOUNT: "Edit_Account",
  ADD_PREFER: "Add_Prefer",
  FORGET_PASS: "Forget_Pass",
  EDIT_ACTIVITY: "EDIT_ACTIVITY",
  Baggage_And_Fares: "Baggage_And_Fares",
  Old_Baggage_And_Fares: "Old_Baggage_And_Fares",
  PREFERENCE: "PREFERENCE",
  EDIT_HOTEL_LOCATION: "Edit_Hotel_Location",
  FLIGHT_BOOKING_SHARE: "flight_booking_Share",
  STAY_BOOKING_SHARE: "stay_booking_Share",
  ACTIVITY_BOOKING_SHARE: "activity_booking_Share",
  PAYMENT_FAILURE: "payment_failure",
  BOOKING_FAILURE: "booking_failure",
  GET_HELP: "Get_Help",
  SELECT_FARE: "Select_Fare",
  REFRESH_FLIGHT_RESULTS: "Refresh_flight_results",
  NETWORK_ERROR_REFRESH_FLIGHT_RESULTS: "NetworkError_Refresh_flight_results",
  REFRESH_STAY_RESULTS: "Refresh_stay_results",
  EXPIRED_FLIGHT_RESULTS: "Expired_flight_results",
  EXPIRED_STAY_RESULTS: "Expired_stay_results",
  EXPIRED_ACTIVITY_RESULTS: "Expired_activity_results",
  NEWLOGIN: "NEWLOGIN",
  LOGIN_WITH_EMAIL: "Login_with_email",
  FLIGHT_PREFERENCE: "Flight_Preference",
  STAY_PREFERENCE: "Stay_Preference",
  ACTIVITY_PREFERENCE: "Activity_Preference",
  FLIGHT_CANCELLATION: "Flight_Cancellation",
  TERMS_CONDITION: "Terms_condition",
  MODIFY_FLIGHTS: "Modify_Flights",
  REMOVE_FLIGHTS: "Remove_Flights",
  EDIT_TRAVELERS: "Edit_Travelers",
  LEAVE_FLIGHT: "Leave_Flight",
  PRICE_CHANGE: "Price_Change",
  SEAT_NOT_AVAILABLE: "Seat_Not_Available",
  DATA_SECURITY: "Data_Security",
  TRAVELER_INFO: "Traveler_Info",
  NO_HOTEL_SELECTED: "No_Hotel_Selected",
  PARTIAL_HOTEL_SELECTION: "Partial_Hotel_Selection",
} as const;

export const APP_CONFIG = {
  HOME_CONSTANT_3: "Home_section_3",
  HOME_CONSTANT_2: "Home_section_2",
  SHOW_MORE: "show_more",
  MODIFY_ITINERARY_PROMPT: "modify_itinerary_prompt",
  MODIFY_DESTINATION_LIST: "want_to_modify_destination_list",
  API_FAILURE_MESSAGE: {
    error: "api_response_bad",
  },
  NO_INTERNET_MESSAGE: {
    info: "no_internet_connection",
  },
  SAVE_ITINERARY_MESSAGE: {
    success: "toast_Itinerary_save",
  },
  LOGIN: "login",
  SIGN_UP: "Sign_up",
  // Feature flag (config table row) gating OTP email verification on signup.
  ENABLE_EMAIL_VERIFICATION: "ENABLE_EMAIL_VERIFICATION",
  // Separate flag gating lead-passenger email prefill + verify-on-change in the
  // traveler/contact form (flights/hotels/activities).
  ENABLE_EMAIL_VERIFICATION_TRAVELER: "ENABLE_EMAIL_VERIFICATION_TRAVELER",
  // Flag controlling whether the (always-prefilled) LEAD traveler email is
  // editable. Truthy ⇒ user can edit it; off/absent ⇒ the field is read-only,
  // locked to the logged-in account email (guests with no account email stay editable).
  MODIFY_TRAVELER_FORM_EMAIL: "MODIFY_TRAVELER_FORM_EMAIL",
  // Feature flag (config table row) gating the "Extra Info" accordion on room-price
  // rows (roomPrices[i].extraInfo — tax-recovery / rate / tariff notes).
  //
  // ⚠️ DEFAULTS ON when the row is ABSENT, unlike every flag above it. This
  // feature is already live in code (featureSwitches.SHOW_NOTES was `true`), so a
  // default-off flag would have SILENTLY REMOVED working content from every
  // environment the moment this shipped, until someone remembered to insert the
  // row. Adding the row is therefore how you turn the feature OFF; see
  // helpers/roomExtraInfo.ts.
  SHOW_ROOM_EXTRA_INFO: "SHOW_ROOM_EXTRA_INFO",
  // Feature flag (config table row) gating whether the /itinerary/prebooking
  // request may carry `requestedItineraryId` — the engine's own itineraryID from
  // a PRIOR successful prebook call in this attempt, sent back only on a later
  // call (e.g. a price-changed re-submit), never on a first attempt or a retry
  // after a failure. Off/absent ⇒ the tag is always omitted. See
  // utils/booking/requestedItineraryId.ts.
  SEND_REQUESTED_ITINERARYID: "SEND_REQUESTED_ITINERARYID",
  // Feature flag (config table row) hiding the "Delete Account" button in the
  // edit-account dialog. Truthy value ⇒ the button is not rendered.
  DISABLE_DELETE_ACCOUNT: "DISABLE_DELETE_ACCOUNT",
  API_RESPONSE_BAD: "api_response_bad",
  NO_INTERNET_CONNECTION: "no_internet_connection",
  TOAST_PROFILE_UPDATE: "toast_profile_update",
  TOAST_PROFILE_ADD: "toast_profile_add",
  TOAST_PREFERENCE_ADD: "toast_preference_add",
  TOAST_PREFERENCE_UPDATE: "toast_preference_update",
  TOAST_RESETPASSWORD_LINK: "toast_resetpassword_link",
  EXPLORE_TRIP_INFO: "explore_trip_info_text",
  ASSISTANCE_INFO_TEXT: "assistance_info_text",
  ENABLE_ACTIVITIES: "ENABLE_ACTIVITIES",
  // Gates the per-activity engagement bar + comment thread (likes /
  // dislikes / comments per time-of-day card). When "true" the
  // ActivityEngagementBar + CommentDrawer render inside each EventCard;
  // when "false" or absent the activity-level engagement is hidden
  // entirely. Itinerary-level engagement is unaffected by this flag.
  ENABLE_ACTIVITY_COMMENTS: "ENABLE_ACTIVITY_COMMENTS",
  IMAGE_SOURCE: "IMAGE_SOURCE",
  ENABLE_MULTI_ACTIVITY: "ENABLE_MULTI_ACTIVITY",
  SHOW_STAY_IMAGES_LIST: "SHOW_STAY_IMAGES_LIST",
  USE_NEW_HOTEL_CARDS: "USE_NEW_HOTEL_CARDS",
  USE_NEW_FLIGHT_CARDS: "USE_NEW_FLIGHT_CARDS",
  USE_NEW_BOOKING_HOTEL_CARDS: "USE_NEW_BOOKING_HOTEL_CARDS",
  USE_NEW_BOOKING_FLIGHT_CARDS: "USE_NEW_BOOKING_FLIGHT_CARDS",
  SHOW_STAYS_MAP: "SHOW_STAYS_MAP",
  STAYS_MAP_AUTO_LOAD: "STAYS_MAP_AUTO_LOAD",
  // When "true", the Share button is shown on the flights+hotels review page
  // (whole-cart share). When "false" (or absent), the Share button is hidden
  // on the review page regardless of cart contents.
  SHOW_REVIEW_SHARE: "SHOW_REVIEW_SHARE",
  // When "true", every freshly-streamed itinerary is auto-mirrored into the
  // TravelPlan table so the chat owner can later share a `/sharedTravelPlan/:id`
  // link, and the Share button rewrites its URL to that new path. When "false"
  // (or absent) the legacy `/shared/:id` path stays in use and no TravelPlan
  // rows are written from the chat flow.
  USE_NEW_TABLE: "USE_NEW_TABLE",
  // Greeting bubble shown above the city image card on the public /shared/:id
  // page. Supports placeholders: {{NAME}} (recipient first name, falls back to
  // "there"), {{CITY NAME}} (the trip's main destination), {{# DAYS}} (number
  // of days). The chat panel renders exactly: pretext bubble → city image
  // card → nothing else (the bubble's postText is intentionally blank).
  TRAVEL_PLAN_PRETEXT: "TRAVEL_PLAN_PRETEXT",
  // When "true", activity payment errors show the raw JSON error details.
  // When "false" (or absent), shows the generic "We couldn't process your booking" message.
  SHOW_BOOKING_ERROR: "SHOW_BOOKING_ERROR",
  // When "true", in-chat search-result widgets (activity / hotel / flight)
  // render the backend-supplied `error` string verbatim. The BE sometimes
  // forwards a raw stringified AxiosError (api keys, stack traces, internal
  // URLs) — useful for diagnosing on dev, leaky on prod. When "false" (or
  // absent), all in-chat search-result error renders fall back to the
  // generic `LLM_RESPONSE_ERROR.jsonError.message` ("Sorry for the
  // inconvenience…") regardless of HTTP status.
  SHOW_INCHAT_ERROR_MESSAGE: "SHOW_INCHAT_ERROR_MESSAGE",
  // When "true", the Stays location input uses the V2 bucket-aware
  // autocomplete: classifies the user's input into one of six buckets
  // (City / Hotel / Area × Exact / Not-Exact) and reorders result groups
  // per bucket with hierarchy POI > City > Hotel > State > Country.
  // When "false" (or absent), the legacy flat predictions list driven by
  // `AutocompleteService` is used.
  USE_HOTEL_SEARCH_V2: "USE_HOTEL_SEARCH_V2",
  // When "true", the Stays location input uses the GA (Google Places API)
  // engine: a two-phase pipeline ported from a standalone reference
  // implementation — Phase 1 fires parallel `AutocompleteSuggestion` +
  // `Place.searchByText` calls, classifies/scores/dedupes the results, and
  // detects a query "mode" (country / city / hotel / area / general); Phase 2
  // fires further mode-targeted text searches (e.g. a city also pulls its
  // airport + top hotels; a bare country fans out into capital/airports/
  // hotels/city-extraction lookups). A bundled Levenshtein-based spell
  // corrector (cities/landmarks/hotel brands/neighborhoods dictionary) both
  // short-circuits obvious typos and re-tries as a fallback. See
  // hooks/gaEngine/ + hooks/useHotelLocationLogicGA.ts. HIGHEST precedence —
  // wins over USE_HOTEL_SEARCH_V2. When "false"/absent, the existing V2 /
  // legacy modes are used unchanged.
  ENABLE_HOTEL_SEARCH_GA_FRONTEND: "ENABLE_HOTEL_SEARCH_GA_FRONTEND",
  // When "true", the Stays location input uses the GA engine (as
  // ENABLE_HOTEL_SEARCH_GA_FRONTEND does — either flag selects GA mode) with
  // the V2 ranking: a half-typed word is never spell-corrected into another
  // place ("frank" stays Frankfurt, not "Banks, OR"); name matching and dedupe
  // ignore punctuation ("st louis" → St. Louis, one Washington D.C.); country
  // mode only on a full country name ("bang" is not Bangladesh-only); and city
  // mode shows only Google's top match — a city or a real area such as South
  // Goa — with its airports and hotels. When "false"/absent, GA mode ranks
  // exactly as before.
  ENABLE_HOTEL_SEARCH_GA_FRONTEND_V2: "ENABLE_HOTEL_SEARCH_GA_FRONTEND_V2",
  // When "true" (with ENABLE_HOTEL_SEARCH_GA_FRONTEND_V2), the Stays location
  // search runs hybrid: the browser keeps the two autocomplete calls and paints
  // the first rows from them, app-backend (POST search/hotels/ga/suggestions)
  // runs the text searches, Phase 2 and ranking. Falls back to the browser
  // pipeline when app-backend fails. Outside production the session override
  // sessionStorage._zenvoya_ga_search_mode = "hybrid" | "browser" wins, so the
  // two can be compared in one tab.
  ENABLE_HOTEL_SEARCH_GA_HYBRID: "ENABLE_HOTEL_SEARCH_GA_HYBRID",
  // When "true", the home-city autocomplete (onboarding + preferences,
  // four call sites) restricts Google Places predictions to city-level
  // entities via the legacy `(cities)` type collection — `locality` +
  // `administrative_area_level_3`. When "false" (or absent), the
  // autocomplete returns unfiltered results, mixing in hotels, parks
  // and other POIs alongside cities (the original behavior). Default
  // is OFF so existing data remains unchanged; flip to "true" to enable
  // city-only filtering.
  HOTEL_CITY_SEARCH: "HOTEL_CITY_SEARCH",
  // When "true", every outbound WS body above 4 KB raw is gzip+base64
  // compressed before send (`{ encoding: "gzip-b64", payload, traceId }`),
  // and the backend WS handler decompresses on receipt. Pushes the API
  // Gateway 128 KB per-message ceiling from ~128 KB raw to ~900 KB raw.
  // When "false" (or absent), all outbound bodies are sent as plain JSON —
  // matching the pre-codec behavior. Backend must support the new envelope
  // before flipping this on; the backend is backward-compatible (still
  // accepts plain JSON), so safe to roll forward incrementally.
  ENABLE_COMPRESSION: "ENABLE_COMPRESSION",
  // When "true", hotel/flight API blobs that the backend stamped into prior
  // assistant `content` strings are re-encoded as TOON (Token-Oriented Object
  // Notation) before being relayed back over the WS. The OUTER envelope and
  // `messages` array shape stay JSON — only the `content` string of an
  // assistant message containing a recognised API response is converted.
  // TOON's tabular form ([N]{keys}:rows) collapses arrays of homogeneous
  // objects (sectors, hotels, segments, stops) to ~40-45% fewer LLM input
  // tokens. Compression (above) operates on the outer wire bytes — TOON
  // operates on LLM tokens; they stack independently.
  //
  // Backend needs NO changes: the `content` strings are opaque to the WS
  // handler, fed straight into the LLM prompt as the prior assistant turn.
  // The LLM parses TOON natively (the format is self-describing). When
  // "false" (or absent), content stays JSON-stringified.
  ENABLE_TOON_ENCODING: "ENABLE_TOON_ENCODING",
  XENIA_ENABLED: "xenia_enabled",
  VOICE_MODE_ENABLED: "voice_mode_enabled",
  CHAT_CHECKOUT_ENABLED: "chat_checkout_enabled",
  // When "true", the FE treats LLM-function WS frames whose agent_key
  // starts with "chat_search" as V2 turns — they share the same v2_block
  // accumulator + renderV2BlocksToChatEntry pipeline as legacy poc_chat
  // turns. When "false" (or absent), chat_search* v2_block frames are
  // SKIPPED with a desync warning in v2orch logs (see
  // DataStreamingContext) so the FE doesn't buffer-and-drop them silently.
  //
  // Distinct DB key from the Lambda's CHAT_SEARCH_V1_ENABLED so the two
  // sides can be flipped independently (e.g. Lambda enabled in dev for
  // smoke-testing while the FE stays on the legacy renderer). Recommend
  // flipping them together in prod to avoid the desync warning.
  CHAT_SEARCH_V1_ENABLED_FRONTEND: "CHAT_SEARCH_V1_ENABLED_FRONTEND",
  // When "true", the itinerary-details "Select Flight" / "Select Stay" CTAs
  // inject an in-chat picker card (flightSelectCard / hotelSelectCard) that
  // collects filters (cabin / stops / dates / stars / etc.) before sending
  // the search prompt to the LLM. When "false" (or absent), the CTAs revert
  // to the legacy pre-fill flow: a natural-language prompt is dropped into
  // the chat input and the user is routed back to chat, where they review
  // and send the prompt themselves. The form path is the newer UX; the
  // pre-fill path is the rollback target if the form needs to be hidden.
  ENABLE_BOOK_FORM: "ENABLE_BOOK_FORM",
  // When "true", the desktop Shop-Travel (chatless) booking renders as a single
  // centered "middle panel" column (gated by `isShopTravelBooking` in
  // DesktopLandingPage). When "false" (or absent), the old method is used: the
  // right booking panel beside the welcome/chat column (the state of revert
  // commit 310e43fd1). Also gates the 3 mobile-branch `setFirstScreen("")`
  // pre-clears (useNewTripLogic / useCustomSideBarLogic / useTabsLogic) for exact
  // rollback parity. Backend-controlled (no rebuild needed to roll back); was a
  // local code switch in featureSwitches.ts before.
  MIDDLE_PANEL_ON: "MIDDLE_PANEL_ON",
  // When "true", the flight/stays results page shows the legacy "Preferences" UI
  // (PreviewSelectedFilters + the gear/Tune button). When "false" (or absent), the
  // new filter bar (FlightFilterEntry / HotelFilterEntry) is shown instead.
  // Backend-controlled (no rebuild); was a local code switch in featureSwitches.ts before.
  SHOW_PREF: "SHOW_PREF",
  // When "true", the popular filter chips (Stops / Airlines / Price / Times /
  // Connecting airports / Duration on flights; Popular / Price / Stars / Guest
  // rating / Property type / Amenities on hotels) open as a Google-Flights-style
  // anchored DROPDOWN below the clicked chip. When "false" (or absent), chips
  // open the centered modal exactly as before. Desktop only — mobile always
  // uses the full-screen sheet. The "All filters" pill continues to open the
  // full modal in both states. Consumer: FlightFilterEntry / HotelFilterEntry
  // desktop chip onSelect. Backend-controlled; was a local code switch in
  // featureSwitches.ts before.
  FILTER_DROPDOWN_ACTIVE: "FILTER_DROPDOWN_ACTIVE",
  // When "true", the Flight Filter's Connecting airports + Nearby airports
  // sections silently DROP entries returned by the backend where ANY of
  // `code`, `name`, `city`, `count` is null / undefined — prevents pills like
  // "NMI null (37)" from rendering. When "false" (or absent), every entry the
  // backend returns is rendered (label falls back to `${code} - ${city ?? name}`).
  // Backend-controlled (no rebuild needed); was a local code switch in
  // featureSwitches.ts before. Consumer: mapFiltersAvailableToTripFixture.ts
  // (via FlightFilterEntry.tsx which resolves the flag from appConfig and
  // passes a boolean down to the pure mapping function).
  DROP_NULL_AIRPORTS: "DROP_NULL_AIRPORTS",
  // When "true", the Hotel Filter panel renders the Neighborhood section
  // (search chips over `data.facets.neighborhoods` / per-city equivalents).
  // When "false" (or absent), the section is skipped entirely — the FAMILIES
  // loop in cityLayouts drops the "neighborhood" entry so the <section>
  // wrapper, title, and body never render. Selection state
  // (`sel.byCity[c].neighborhood[]`) is untouched — hidden UI, no data reset.
  // Backend-controlled; was a local code switch in featureSwitches.ts before.
  // Consumer: cityLayouts.tsx (both All + Per-City FAMILIES loops).
  SHOW_NEIGHBORHOOD: "SHOW_NEIGHBORHOOD",
  // When "true", any Hotel Filter section whose facet is empty ({}/[]/missing)
  // is HIDDEN entirely — the <section> wrapper, title, and empty note are all
  // skipped. When "false" (or absent), the section still renders with a muted
  // "No Filter Available for this" note inside its body. Applies to the 9
  // facet-driven families: popular, stars, guestRating, propertyType,
  // mealPlan, brand, hotelAmenities, roomAmenities, neighborhood.
  // propertyName / distance are unaffected. Backend-controlled; was a local
  // code switch in featureSwitches.ts before. Consumer: cityLayouts.tsx
  // (both All + Per-City FAMILIES loops).
  //
  // ALSO reused by the FLIGHT Filter with the same semantic. When "true":
  // - Array families (Stops / Airlines / Connecting airports / Nearby airports)
  //   whose data is [] or missing in EVERY leg are hidden.
  // - Range sections (Flight duration / Layover duration / Price /
  //   Departure & arrival times) whose `min === max` (collapsed) in EVERY leg
  //   are hidden.
  // Multi-city aggregation: if ANY leg has non-blank data → the section stays
  // visible everywhere; only when EVERY leg is blank is the section removed
  // from BOTH the All view AND every per-leg tab (and the matching popular
  // chip). Consumer: FlightFilterEntry.tsx (resolves the flag from appConfig,
  // passes a boolean into `computeVisibleSections(trip, hideBlank)` in
  // legFilterControls.tsx; the Set is threaded through the VM into
  // legLayouts.tsx's FAMILIES loops + the price section gate).
  HIDE_BLANK_FILTER_SECTION: "HIDE_BLANK_FILTER_SECTION",
  // When "true", the Per-city tab body in the Hotel Filter panel shows the
  // "No stays found" empty state (the same NoDataFound used by the results
  // page) when the active city has zero hotels — replacing the price slider
  // + family sections. All mode, CityTabs strip, and cities-with-hotels tabs
  // are untouched. When "false" (or absent), the tab body renders as it does
  // today (price + families visible even for empty cities). Backend-
  // controlled. Consumer: cityLayouts.tsx (Per-City branch only).
  SHOW_EMPTY_CITY_UI_IN_FILTER: "SHOW_EMPTY_CITY_UI_IN_FILTER",
  // When "true", the "Distance from city center" filter renders a
  // dual-thumb slider with both min and max draggable.
  // When "false" (or absent — default), the min thumb is hidden and
  // locked at `facets.distance.min`; only the max thumb slides — and a
  // click anywhere on the track jumps the max to that spot. Outgoing
  // selection is always `[facets.distance.min, chosen_max]`. Backend-
  // controlled. Consumer: cityFilterControls.tsx (distance case in
  // `renderFamily`), plumbed from cityLayouts.tsx + HotelFilterEntry.tsx.
  SLIDE_MIN_DISTANCE: "SLIDE_MIN_DISTANCE",
  // Unit shown on the "Distance from city center" filter + the payload
  // field used on /hotel/search.
  //   "true" → km. UI label "km"; payload writes the picked max to
  //     `selectedFilters.maxDistanceKm`.
  //   "false" (or absent — default) → miles. UI label "mi"; payload
  //     writes to `selectedFilters.maxDistanceMiles`.
  // The numeric slider range (0–10) is unchanged; only the unit label
  // and the outgoing field name differ. Backend-controlled. Consumers:
  // cityFilterControls.tsx (distance case in `renderFamily`) +
  // mapSelectionToHotelSelectedFilters.ts (payload builder), plumbed
  // from cityLayouts.tsx + HotelFilterEntry.tsx.
  DISTANCE_KM_IN_FILTER: "DISTANCE_KM_IN_FILTER",
  // Master switch for the hotel / flight / activity GST copy. A surface renders
  // GST only when this is "true" AND its own row below is "true" AND the pricing
  // carries GST. "false" (or absent — default) hides all of it and the existing
  // "Taxes & fees included" copy stays. Backend-controlled. Consumers read the
  // set through resolveGstFlags (utils/appConfig) and pass a boolean into the
  // pure adapters or gate the render directly.
  SHOW_GST_TAG: "SHOW_GST_TAG",
  // "Includes GST" under the search-card price (hotel, flight, activity; chat +
  // Shop Travel + stays map) and on the checkout review card. Absent → off.
  GST_SEARCH: "GST_SEARCH",
  // "GST, Taxes & fees included" on the bottom footers: hotel detail, room
  // select, flight detail, flight fares, activity detail / availability /
  // preferences. Absent → off.
  GST_BOTTOM_DRAWER: "GST_BOTTOM_DRAWER",
  // "GST included in tax" under "Taxes & Fees" on the review / payment price
  // breakdown, plus "GST, Taxes & fees included" on the review page's mobile
  // price drawer. Absent → off.
  GST_PAYMENT_REVIEW: "GST_PAYMENT_REVIEW",
  // Adds the amount to that review note ("GST included in tax - $6.97"). Only
  // read when GST_PAYMENT_REVIEW is on. "false" (or absent) → the note shows
  // without the amount.
  GST_PAYMENT_REVIEW_AMT: "GST_PAYMENT_REVIEW_AMT",

  BUILD_VERSION: "BUILD_VERSION",

  ACTIVATE_BUILD_CLEANUP: "ACTIVATE_BUILD_CLEANUP",

  ENABLE_JOI_VALIDATION: "ENABLE_JOI_VALIDATION",

  // Feature flag (config table row) gating the two WebBeds-driven behaviours on the
  // stays booking flow, BOTH off unless the row says on (nothing here is live today):
  //
  //   1. "Extra Info" — the button under "Pay now" on the review price panel, which
  //      opens the property's check-in instructions / mandatory + optional fees /
  //      "know before you go" text from `/price/review`
  //      (`fareBreakdown.hotels[i].extraInfo`). No extraInfo in the response ⇒ no
  //      button, flag or not.
  //   2. "All pax details" — when the priced rate comes back with
  //      `allPaxDetailsRequired: true`, the stays traveler step collects the name
  //      fields for EVERY guest (children included) instead of the lead guest only.
  //      WebBeds requires the full guest list for those rates.
  //
  // One row for both because they are one supplier requirement arriving together in
  // the same response; the room-level "Extra Info" accordion is a different feature
  // with its own row (SHOW_ROOM_EXTRA_INFO) and is untouched by this flag.
  WEBBED_EXTRA_INFO_ENABLED: "WEBBED_EXTRA_INFO_ENABLED",

} as const;


export const FLIGHT_PAGE_SIZE = 30;

export const FLIGHT_MAX_RESULTS_SAFETY_CAP = 560;

export const HOTEL_PAGE_SIZE = 30;

export const HOTEL_MAX_RESULTS_SAFETY_CAP = 560;

// Max length of the free-text trip-preferences ("aboutMe") field. Must stay in
// sync with the backend: the `aboutMe` maxLength in preferencesSchema and the
// varchar(2000) column on the UserPreferences entity.
export const ABOUT_ME_MAX_LENGTH = 2000;


export const PROMPT = {
  // SHOW_MORE: "Show 2 more cities",
  SHOW_MORE:
    "Suggest  2 more new destinations in addition to your last recommendations. Don't include anything you have already suggested.",
  // SHOW_MORE: "Give only 2 more city or results or destination not more than 2"
} as const;

export const emailRegex =
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const alphaNumericRegex = new RegExp(/^[a-z0-9]+$/i);

// Loose check (7–15 digits). Strict per-country validation is done via libphonenumber-js.
export const phoneRegex = /^(?:\D*\d){7,15}\D*$/;

export const replaceNewlineWithSpaceRegex = /\n/g;

export const jsonPatternRegex = /\{.*\}/;

export const LLM_RESPONSE_ERROR = {
  jsonError: {
    error: "JSON_ERROR",
    message:
      "Sorry for the inconvenience, but it seems like we're having trouble processing your request. Please try again.",
  },
  timeOut: {
    error: "TIME_OUT",
    message: "Sorry, our system is too busy at this time to load your itinerary. Please try again later.",
  },
};

export const INVALID_JSON_PROMPT = ". Please provide a vaild and parseable JSON.";

export function isAlphaNumericString(input: string) {
  return input.split("").some((item: any) => !isNaN(item));
}

function daysInMonth(month: number, year: number) {
  return new Date(year, month, 0).getDate();
}

// Validate a simple date string
export function isValidDate(dateString: string) {
  if (
    daysInMonth(Number(dateString.split("-")[1]), Number(dateString.split("-")[0])) >= Number(dateString.split("-")[2])
  )
    return true;
  return false;
}

export const WeatherIconCode = {
  CloudBolt: ["1087", "1273"],
  CloudBoltMoonLight: [""],
  CloudBoltSunLight: ["1063"],
  CloudDrizzleLight: ["1189", "1153", "1180", "1183", "1186", "1189"],
  CloudHailLight: ["1204", "1207", "1237"],
  CloudLight: ["1006"],
  CloudShowerHeavyLight: ["1192", "1195", "1276"],
  CloudLigths: ["1003", "1009"],
  HurricaneLight: [""],
  MoonStarsLight: [""],
  RaindropsLight: [""],
  SnowflakeLight: ["1066", "1147", "1210", "1213", "1216", "1219", "1222"],
  SunCloudLight: ["1150"],
  SunLight: ["1000"],
  TemperatureSnowLight: ["1168", "1171", "1282"],
  TemperatureSunLight: [""],
  TornadoLight: [""],
  WindLight: [""],
};

export const API_HEADER = {
  "Content-Type": "application/json;charset=UTF-8",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Headers": "*",
};

export const BRAND_NAME = _brandManifest.name;

export const CHAT_BOT_NAME = {
  name: _brandManifest.assistantName,
};

export const OPEN_TRIP_FROM_URL = {
  userActionLogin: "USER_ACTION_LOGIN",
};

export const LOCAL_STORAGE_KEY = {
  deviceId: "_zenvoya_device_id",
};

export const SOCKET_CONNECTION_TYPE = {
  unInstantiated: "unInstantiated",
  connecting: "connnecting",
  open: "open",
  closing: "closing",
  closed: "closed",
};

export const TRAVELER_FORM_KEYS = {
  IS_NEW_TRAVELER: "isNewTraveler",
  EXTRA_ID: "extraId",
  ID: "id",
  COLLAPSE: "collapse",
  COLLAPSE_ADDITIONAL_INFO: "collapseAdditionalInfo",
  FIRST_NAME: "firstName",
  MIDDLE_NAME: "middleName",
  LAST_NAME: "lastName",
  DATE_OF_BIRTH_MONTH: "dateOfBirthMonth",
  DATE_OF_BIRTH: "dateOfBirth",
  DATE_OF_YEAR: "dateOfYear",
  GENDER: "gender",
  EMAIL: "email",
  DOCUMENT_TYPE: "documentType",
  DOCUMENT_NUMBER: "documentNumber",
  ISSUING_COUNTRY: "issuingCountry",
  NATIONALITY: "nationality",
  DOC_ISSUE_MONTH: "docIssueMonth",
  DOC_ISSUE_DATE: "docIssueDate",
  DOC_ISSUE_YEAR: "docIssueYear",
  DOC_EXPIRY_MONTH: "docExpiryMonth",
  DOC_EXPIRY_DATE: "docExpiryDate",
  DOC_EXPIRY_YEAR: "docExpiryYear",
  COUNTRY_CODE: "countryCode",
  PHONE_NUMBER: "phoneNumber",
  PROGRAM_NAME: "programName",
  FREQUENT_FLYER_NUMBER: "frequentFlyerNumber",
  PASSPORT_NUMBER: "passportNumber",
  MEAL_PREF: "mealPref",
  SELECTED_OPTIONS: "selectedOptions",
  REQUIRED_DATA_FILLED: "requiredDataFilled",
  ROOM_INFO: "roomInfo",
  PAX_TYPE: "paxType",
} as const;
